<template>
  <div>
    <DetailDialog ref="detailDialog" />
    <qx-card title="维保申请" class="detail" v-loading="loading">
      <!-- 订单详情数据 -->
      <qx-detail-box
        :data="detailData.base"
      />
      <!-- 明细信息 -->
      <qx-card-inline title="明细信息">
        <section class="detailOtherInfo">
          <el-table
            class="tableBox"
            :data="originData.costDetails"
            tooltip-effect="dark"
          >
            <!-- 常规列表项 -->
            <el-table-column
              v-for="(item, index, key) in tableTitle"
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :min-width="item.minW"
              :width="item.w"
            />
          <!-- 操作按钮 -->
          <el-table-column prop="control" label="操作" width="160" fixed="right">
            <template slot-scope="scope">
              <section>
                <!-- 操作按钮 -->
                <qx-permpisions permpisions="">
                  <span class="primary cur" @click="showDetail(scope.row)">查看</span>
                </qx-permpisions>
              </section>
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
          </el-table>
        </section>
      </qx-card-inline>
      <qx-detail-box
        :data="detailData.receipt"
      />
      <!-- 订单详情数据 end -->
    </qx-card>
    <ApproveBox
      v-if="(type ||$route.query.type) === 'approve'"
      :busiId="id ? String(id) : $route.query.id"
      busiCode="22000048"
      :inFast="Boolean(id)"
      :handleRefresh="handleRefresh"
    />
  </div>
</template>

<script>
import {
  maintenanceDetail, // 获取详情
} from 'api/cost';
import ApproveBox from 'components/approveBox';
import DetailDialog from './detailDialog';
export default {
  components: {
    ApproveBox,
    DetailDialog,
  },
  props: {
    id: {
      type: Number,
    },
    type: {
      type: String,
    },
    handleRefresh: {
      type: Function,
      default: () => {},
    },
  },
  data () {
    return {
      loading: false,
      tableTitle: [
        {
          prop: 'plateNumber',
          label: '车牌号码',
        },
        {
          prop: 'payAmt',
          label: '申请金额',
        },
        {
          prop: 'userName',
          label: '司机姓名',
        },
        {
          prop: 'mobilePhone',
          label: '司机手机',
        },
        {
          prop: 'orderId',
          label: '订单号码',
        },
      ],
      originData: {},
      detailData: {
        base: {
          label: '维保申请',
          tableData: {
            title: [
              {
                prop: 'applyUserName',
                label: '申请人',
              },
              {
                prop: 'updateTime',
                label: '申请时间',
              },
              {
                prop: 'applyCode',
                label: '申请单号',
              },
              {
                prop: 'applyTypeName',
                label: '费用类型',
              },
              {
                prop: 'orgName',
                label: '费用归属',
              },
              {
                prop: 'preAmt',
                label: '预估费用',
              },
              {
                prop: 'productName',
                label: '维修站点',
              },
              {
                prop: 'serviceName',
                label: '服务商',
              },
              {
                prop: 'feeAscriptionDate',
                label: '费用归属日期',
              },
              // {
              //   prop: 'address',
              //   label: '上传图片',
              //   slot: 'img',
              // },
              {
                prop: 'repairReson',
                label: '申请原因',
              },
              {
                prop: 'amtRemark',
                label: '费用说明',
              },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
        receipt: {
          label: '收款信息',
          tableData: {
            title: [
              {
                prop: 'receName',
                label: '收款方名称',
              },
              {
                prop: 'receUserName',
                label: '收款账户名',
              },
              {
                prop: 'receBankName',
                label: '收款银行',
              },
              {
                prop: 'receBankNo',
                label: '收款账号',
              },
              {
                prop: 'userTypeName',
                label: '收款人类型',
              },
              {
                prop: 'balanceTypeName',
                label: '结算方式',
              },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
      },
    };
  },
  computed: {
    colSpan () {
      const total = 24;
      const minSpan = 4;
      return parseInt(total / this.orderInfo.length, 10) < minSpan ? minSpan : parseInt(total / this.orderInfo.length, 10);
    },
  },
  watch: {
    '$route.query.id': function () {
      this.getData();
    },
  },
  methods: {
    showDetail (item) {
      this.$refs.detailDialog.show(item);
    },
    async getData () {
      if (this.$route.path !== '/manage/cost/car/apply/costDetail' && !this.id) {
        return;
      }
      this.loading = true;
      const detailRes = await maintenanceDetail({
        applyId: this.id || this.$route.query.id,
        isEdit: 2,
      });
      this.loading = false;
      if (!detailRes.failed) {
        detailRes.costDetails[0].beforePicList.forEach((item, index) => {
          this.detailData.base.tableData.title.push({
            label: `上传图片${index + 1}`,
            prop: `pic${index + 1}`,
            type: 'img',
          });
          detailRes[`pic${index + 1}`] = item.fileUrl;
        });
        // if (this.$route.query.type) {
        //   this.detailData.base.tableData.approveData = detailRes.ver;
        // }
        this.detailData.base.tableData.data = {
          ...detailRes,
          ...detailRes.costDetails[0],
        };
        this.detailData.receipt.tableData.data = this.originData = detailRes;
      }
    },
  },
  created () {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
@import "styles/config.scss";
.orderStatusBox{
  overflow: auto;
}
.orderInfoBox{
  margin: 16px 12px 0;
  min-height: 124px;
  border: 1px solid $border-color;
  padding: 24px 16px;
  box-sizing: border-box;
  .title{
    font-size: 16px;
    height: 16px;
    line-height: 16px;
    padding-bottom: 16px;
  }
  .desc,.time{
    color: #666;
    line-height: 16px;
  }
  .desc{
    padding-bottom: 12px;
  }
}
.box{
  border-top: 1px solid $border-color;
  border-left: 1px solid $border-color;
  border-right: 1px solid $border-color;
}
.itemLabel{
  background: $grey;
}
.itemLabel,.itemText{
  height: 48px;
  line-height: 48px;
  padding: 0 24px;
  box-sizing: border-box;
  border-bottom: 1px solid $border-color;
}
</style>
